import {
  Component,
  OnInit,
  ViewChild,
  Input,
  ElementRef,
  Renderer2,
} from "@angular/core";
import { Router } from "@angular/router";
import { AuthServiceService } from "src/app/services/auth-service.service";
import { NgbTooltipConfig, NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { SearchPageService } from "src/app/views/searchpage/searchpage.service";
import { GsdRoles } from "src/app/enums/gsdRoles.enum";
import { EmployeeService } from "src/app/views/employee-profile/employee-profile.service";
import { InfoDialogComponent } from "../info-dialog/info-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import { LoaderService } from "../loader/loader.service";
import { error } from "console";
import { Sidebar2Service } from "../sidebar2/sidebar2.service";
import { ConfirmationActionDialogComponent } from "../confirmation-back-dialog/confirmation-action-dialog/confirmation-action-dialog.component";
import { MatMenu } from "@angular/material/menu";

declare var $: any;

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
export class HeaderComponent implements OnInit {
  public loading = false;
  adminRole = 1;
  public backgroundColor = false;
  public username: string;
  public useremail: string;
  public role: string;
  canViewSideMenu = true;
  public from: number;
  public size: number = 5;
  superAdmin: boolean = false;
  showViewMore: boolean = false;
  notificationsData: any;
  totalNotifications: number;
  userRole: boolean = false;
  tipContent: string;
  isAutoStarted: boolean;
  @Input("demoIcon") demoIcon: boolean;

  @ViewChild("tooltip") public tooltip: NgbTooltip;
  public homePageFlag: boolean;
  @ViewChild(MatMenu) notificationsMenu: MatMenu;
  isSidebarOpen: boolean = false;

  constructor(
    private router: Router,
    config: NgbTooltipConfig,
    private searchPageService: SearchPageService,
    private dialog: MatDialog,
    private employeeService: EmployeeService,
    private toastr: ToastrService,
    private loadingService: LoaderService,
    public toggleSidebar: Sidebar2Service,
    private auth: AuthServiceService,
    private empService: EmployeeService
  ) {
    this.homePageFlag = this.router.url == "/home" && this.demoIcon;
  }

  ngAfterContentChecked() {
    this.homePageFlag = this.router.url == "/home" && this.demoIcon;
  }

  ngAfterViewInit() {
    if (this.homePageFlag) {
    }
    setTimeout(() => {
      this.notificationsMenu['_body']?.nativeElement?.addEventListener('scroll', this.onScroll.bind(this));
    }, 100);
  }

  redirectToHome() {
    this.searchPageService.ictSearchTerm = "";
    this.searchPageService.searchOptions.searchTerm = "";
    if (this.role.includes(GsdRoles.Leadership)) {
      this.router.navigate(["/Home"]);
    } else if (
      this.role.includes(GsdRoles.CompetencyLeader) ||
      this.role.includes(GsdRoles.SubCompetencyLeader)
    ) {
      this.router.navigate(["/Home"]);
    } else if (this.role.includes(GsdRoles.SkillUser)) {
      this.router.navigate(["/Dashboard"]);
    } else {
      this.router.navigate(["/Home"]);
    }
    this.toggleSidebar.sidebarShow = false;
  }

  ngOnInit() {
    this.role = this.auth.getRole();
    //if(this.role){}
    if (this.role?.includes(GsdRoles.SuperAdmin)) {
      this.adminRole = 0;
      this.superAdmin = true;
      this.setAutosyncData();
    } else {
      this.adminRole = 1;
    }
    if (this.role?.includes(GsdRoles.CompetencyLeader)) {
      this.adminRole = 0;
    }
    if (this.role?.includes(GsdRoles.SubCompetencyLeader)) {
      this.adminRole = 0;
    }
    if (this.role?.includes(GsdRoles.Leadership)) {
      this.adminRole = 0;
    }
    if (this.role?.includes(GsdRoles.Admin)) {
      this.adminRole = 0;
    }
    if (this.role?.includes(GsdRoles.SkillUser)) {
      this.userRole = true;
      this.adminRole = 0;
      this.from = 0;
      this.loadNotifications(false);
    }
    this.useremail = this.auth.getEmailId();

    if (!this.role?.includes(GsdRoles.SuperAdmin)) {
      this.canViewSideMenu = false;
    }
    if (this.role?.includes(GsdRoles.SkillUser)) {
      this.canViewSideMenu = true;
    }
    if (this.role?.includes(GsdRoles.CompetencyLeader)) {
      this.canViewSideMenu = true;
    }
    if (this.role?.includes(GsdRoles.SubCompetencyLeader)) {
      this.canViewSideMenu = true;
    }
    if (this.role?.includes(GsdRoles.Leadership)) {
      this.canViewSideMenu = true;
    }
    if (this.role?.includes(GsdRoles.Admin)) {
      this.canViewSideMenu = true;
    }
    if (this.useremail)
      this.username = this.useremail.split("@")[0].split(".").join(" ");
  }
  public addPreferances() {
    this.loading = true;
    this.router
      .navigate(["Home/Preferances"])
      .then((nav) => (this.loading = false))
      .catch((err) => {
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: "280px",
          data: { message: "Cannot Open", class: "text-danger" },
        });
      });
  }
  public ReminderAndEscalations() {
    this.loading = true;
    this.router
      .navigate(["Home/Reminder and Escalations"])
      .then((nav) => (this.loading = false))
      .catch((err) => {
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: "280px",
          data: { message: "Cannot Open", class: "text-danger" },
        });
      });
  }
  loadNotifications(viewMore) {
    this.empService.getUserNotifications(this.from, this.size).subscribe(
      (x) => {
        if (viewMore)
          this.notificationsData = this.notificationsData.concat(x.data.items);
        else this.notificationsData = x.data.items;
        if (this.notificationsData.length <= x.data.total)
          this.showViewMore = false;
        if (x.data.total > this.from + this.size) this.showViewMore = true;
        this.totalNotifications = x.data.unreadCount;
      },
      (error) => { }
    );
  }
  readclick() {
    this.readNotification();
  }
  showMoreNotifications() {
    this.from += this.size;
    this.showViewMore = false;
    this.loadNotifications(true);
    event.stopPropagation();
  }

  readNotification() {
    let data = this.notificationsData.filter((item) => item.isRead == false);
    let ids: any = [];
    data.forEach((x) => {
      ids.push(x.id);
    });
    if (ids.length > 0) {
      this.empService.updateNotification(ids).subscribe((res) => {
        if (res) {
          data.forEach((item) => {
            item.isRead = true;
          });
          if (this.totalNotifications > 0) {
            this.totalNotifications = this.totalNotifications - data.length;
          }
          //this.loadNotifications(false);
        }
      });
    }
  }

  onClick(event) {
    this.readNotification();
  }

  onScroll(event) {
    const element = event.target as HTMLElement;
    if (
      element.scrollHeight - element.scrollTop <=
      element.clientHeight + 100
    ) {
      if (this.showViewMore) {
        this.showMoreNotifications();
      } else {
        this.readNotification();
      }
    }
  }

  getUserName(name) {
    if (name) {
      return name[0].toUpperCase();
    }
  }
  public openSidebar(event) {
    this.toggleSidebar.updateSidebarshow(!this.toggleSidebar.sidebarShow);
    if ($("#sidebar_r").hasClass("active")) {
      $("#sidebar_r").removeClass("active");
    }
    $("#sidebaryu").addClass("active");
    $(".overlay").addClass("active");
    $(".collapse.in").toggleClass("in");
    $("a[aria-expanded=true]").attr("aria-expanded", "false");
  }
  public dismissSidebar() {
    $("#sidebaryu").removeClass("active");
    $(".overlay").removeClass("active");
    this.toggleSidebar.updateSidebarshow(false);
  }


  showDemo() {
    this.router
      .navigate(["/Home"])
      .then((s) => setTimeout((s) => this.auth.demo.next(true), 200));
  }
  logout() {
    this.loading = true;
    localStorage.clear();
    this.router.navigate(["/login"]);
  }

  redirectToHomePage() {
    this.router.navigate(["./Dashboard"]);
  }
  public rolesNavigate() {
    this.loading = true;
    this.router
      .navigate(["Home/Add Roles"])
      .then((nav) => (this.loading = false))
      .catch((err) => {
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: "280px",
          data: { message: "Cannot Open", class: "text-danger" },
        });
      });
  }
  public bulkUploadNavigate() {
    this.loading = true;
    this.router
      .navigate(["Home/dataupload"])
      .then((nav) => (this.loading = false))
      .catch((err) => {
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: "280px",
          data: { message: "Cannot Open", class: "text-danger" },
        });
      });
  }
  public employeeDataNavigate() {
    this.loading = true;
    this.router
      .navigate(["Home/employeedata"])
      .then((nav) => (this.loading = false))
      .catch((err) => {
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: "280px",
          data: { message: "Cannot Open", class: "text-danger" },
        });
      });
  }
  public employeeDataNoCompetency() {
    this.loading = true;
    this.router
      .navigate(["Home/Missing-mandatory-fields"])
      .then((nav) => (this.loading = false))
      .catch((err) => {
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: "280px",
          data: { message: "Cannot Open", class: "text-danger" },
        });
      });
  }


  OpenOrganizationalCompliance() {
    this.loading = true;
    this.router.navigate(['Home/Organizational-Compliance'])
      .then(nav => this.loading = false)
      .catch(err => {
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: "280px",
          data: { message: "Cannot Open", class: "text-danger" },
        });
      });
  }

  bulkUploadEmployees() {
    if (!this.isAutoStarted) {
      const dialogRef = this.dialog.open(ConfirmationActionDialogComponent, {
        width: "400px",
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result.data === "CONFIRM") {
          this.employeeService.bulkUploadEmployees().subscribe(
            (res) => {
              this.getAutoSyncStatus();
              localStorage.setItem("autoSync", "false");
              this.isAutoStarted = false;
            },
            (error) => {
              this.getAutoSyncStatus();
              localStorage.setItem("autoSync", "false");
              this.isAutoStarted = false;
            }
          );
          this.isAutoStarted = true;
          localStorage.setItem("autoSync", "true");
          this.loadingService.isLoading.next(false);
          this.tipContent = "Autosync Started";
        } else if (result.data === "CANCEL") {
          return;
        }
      });
    }
  }
  getAutoSyncStatus() {
    this.employeeService.getLastAutoSync().subscribe((res) => {
      this.tipContent =
        "Last Sync on " +
        new Date(res.data.createdDate).toLocaleDateString() +
        " " +
        new Date(res.data.createdDate).toLocaleTimeString() +
        " New employees: " +
        res.data.employeeCount;
      localStorage.setItem("autoSyncStatus", this.tipContent);
    });
  }
  setAutosyncData() {
    let autoSyncStaus = localStorage.getItem("autoSync");
    this.isAutoStarted = JSON.parse(autoSyncStaus);
    if (this.isAutoStarted) {
      this.tipContent = "Autosync Started";
    } else {
      let lastSyncStatus = localStorage.getItem("autoSyncStatus");
      if (lastSyncStatus) {
        this.tipContent = lastSyncStatus;
      } else {
        this.getAutoSyncStatus();
      }
    }
  }
  public projectDataNavigate() {
    this.loading = true;
    this.router
      .navigate(["Home/projectdata"])
      .then((nav) => (this.loading = false))
      .catch((err) => {
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: "280px",
          data: { message: "Cannot Open", class: "text-danger" },
        });
      });
  }

  toggleSideNavbar(): void {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  onOverlayClick(): void {
    this.isSidebarOpen = false;
  }

  updateSideBarCollapse(event) {
    this.isSidebarOpen = event.isSideBarOpen;
  }
}
